module.exports = __webpack_public_path__ + "media/images/icons/pin-fill-f2cd91c73e76afe557233077008a1caa.png";